<template>
  <!-- 通用组件：不光设备中用到该组件,人员管理新增部门,新增耗材工具-->
  <div>
    <div v-if="val.c_func===null||val.c_func===undefined">
      <div>
        <inputBox v-if="val.c_data_type==='Str'"
                  :Data="{'obj':objType,'data':val,'attr':{'type':type,'oneIndex':oneIndex,'twoIndex':index_x}}"></inputBox>
      </div>
      <!--  数字组件-->
      <div>
        <number v-if="val.c_data_type==='Num'||val.c_data_type==='Numf'"
                :Data="{'obj':objType,'data':val,'attr':{'type':type,'oneIndex':oneIndex,'twoIndex':index_x}}"></number>
      </div>
      <div>
        <nums v-if="val.c_data_type==='Nums'"
                :Data="{'obj':objType,'data':val,'attr':{'type':type,'oneIndex':oneIndex,'twoIndex':index_x}}"></nums>
      </div>
      <!--      数字范围-->
      <div>
        <numr v-if="val.c_data_type==='Numr'"
                :Data="{'obj':objType,'data':val,'attr':{'type':type,'oneIndex':oneIndex,'twoIndex':index_x}}"></numr>
      </div>
      <!--  单选框组件-->
      <div>
        <radio :Data="{'obj':objType,'data':val,'attr':{'type':type,'oneIndex':oneIndex,'twoIndex':index_x}} "
               v-if="val.c_data_type === 'Enum'"></radio>
      </div>
      <!--   多选组件-->
      <div>
        <checkbox
            :Data="{'obj':objType,'data':val,'attr':{'type':type,'oneIndex':oneIndex,'twoIndex':index_x}} "
            v-if="val.c_data_type === 'MEnum'"></checkbox>
      </div>
      <!--  bool类型-->
      <div>
        <bool-switch
            :Data="{'obj':objType,'data':val,'attr':{'type':type,'oneIndex':oneIndex,'twoIndex':index_x}} "
            v-if="val.c_data_type === 'Bool'"></bool-switch>
      </div>
      <!--  输入框范围-->
      <div>
        <input-range
            :Data="{'obj':objType,'data':val,'attr':{'type':type,'oneIndex':oneIndex,'twoIndex':index_x}} "
            v-if="val.c_data_type === 'Numr'"></input-range>
      </div>
      <!--   日期时间组件    编辑工单的开始结束时间不能小于当前-->
      <div>
        <DTime v-if="val.c_data_type==='DTime'"
                     :Data="{'obj':objType,'data':val,'attr':
                                    {'type':type,'oneIndex':oneIndex,'twoIndex':index_x,
                                    'showAll':objType==='editOrder'?false:true}}"></DTime>
      </div>
      <div>
        <DTimer v-if="val.c_data_type==='DTimer'"
               :Data="{'obj':objType,'data':val,'attr':
                                    {'type':type,'oneIndex':oneIndex,'twoIndex':index_x,
                                    'showAll':objType==='editOrder'?false:true}}"></DTimer>
      </div>
      <div>
        <DTimers v-if="val.c_data_type==='DTimers'"
                :Data="{'obj':objType,'data':val,'attr':
                                    {'type':type,'oneIndex':oneIndex,'twoIndex':index_x,
                                    'showAll':objType==='editOrder'?false:true}}"></DTimers>
      </div>
      <div>
        <DTimes v-if="val.c_data_type==='DTimes'"
               :Data="{'obj':objType,'data':val,'attr':
                                    {'type':type,'oneIndex':oneIndex,'twoIndex':index_x,
                                    'showAll':objType==='editOrder'?false:true}}"></DTimes>
      </div>
         <!--      单个日期组件-->
      <div>
        <date  v-if="val.c_data_type==='Date'"
               :Data="{'obj':objType,'data':val,'attr':
                        {'type':type,'oneIndex':oneIndex,'twoIndex':index_x, }}"> </date>
      </div>
      <!--      多个-日期量-->
      <div>
        <dates  v-if="val.c_data_type==='Dates'"
               :Data="{'obj':objType,'data':val,'attr':
                        {'type':type,'oneIndex':oneIndex,'twoIndex':index_x, }}"> </dates>
      </div>

      <!--      单个-日期量范围-->
      <div>
        <dater  v-if="val.c_data_type==='Dater'"
               :Data="{'obj':objType,'data':val,'attr':
                        {'type':type,'oneIndex':oneIndex,'twoIndex':index_x }}"> </dater>
      </div>
      <!--      多个-日期量范围-->
      <div>
        <daters  v-if="val.c_data_type==='Daters'"
                :Data="{'obj':objType,'data':val,'attr':
                        {'type':type,'oneIndex':oneIndex,'twoIndex':index_x, }}"> </daters>
      </div>
      <!--      单个-时间量-->
      <div>
        <Time v-if="val.c_data_type==='Time'"
              :Data="{'obj':objType,'data':val,'attr':
                                    {'type':type,'oneIndex':oneIndex,'twoIndex':index_x}}"></Time>

      </div>
      <!--      多个-时间量-->
      <div>
        <times v-if="val.c_data_type==='Times'"
              :Data="{'obj':objType,'data':val,'attr':
                                    {'type':type,'oneIndex':oneIndex,'twoIndex':index_x}}"></times>
      </div>
<!--      单个-时间范围组件-->
      <div>
        <timer v-if="val.c_data_type==='Timer'"
                    :Data="{'obj':objType,'data':val,'attr':
                                    {'type':type,'oneIndex':oneIndex,'twoIndex':index_x}}"></timer>
      </div>
      <!--      多个-时间范围组件-->
      <div>
        <timers v-if="val.c_data_type==='Timers'"
               :Data="{'obj':objType,'data':val,'attr':
                                    {'type':type,'oneIndex':oneIndex,'twoIndex':index_x}}"></timers>
      </div>


      <!--   txt-->
      <div>
        <txt v-if="val.c_data_type==='Txt'"
             :Data="{'obj':objType,'data':val,'attr':
                      {'type':type,'oneIndex':oneIndex,'twoIndex':index_x,'des_id':des_id,'des_name':des_name}}"></txt>
      </div>
      <!--   附件-->
      <div>
        <fileAccess v-if="val.c_data_type==='Attachment'||val.c_data_type==='Attachments'"
                    :Data="{'obj':objType,'data':val,'attr':{'type':type,'oneIndex':oneIndex,'twoIndex':index_x,
                    'des_id':des_id,'des_name':des_name}}"
                    :ref="'fileUpLoad'+index_x"></fileAccess>
      </div>
      <!--            图片-->
      <!--      <div>-->
      <!--        <Images v-if="val.c_data_type==='Img'"-->
      <!--                :Data="{'obj':objType,'data':val,'attr':{'type':type,'oneIndex':oneIndex,'twoIndex':index_x,-->
      <!--                'des_name':des_name,'des_id':des_id}}"-->
      <!--                :ref="'fileUpLoad'+index_x"></Images>-->
      <!--      </div>-->
      <!--            多个图片-->
      <div>
        <imgs v-if="val.c_data_type==='Imgs'||val.c_data_type==='Img'"
              :Data="{'obj':objType,'data':val,'attr':{'type':type,'oneIndex':oneIndex,'twoIndex':index_x,
              'des_id':des_id,'des_name':des_name}}"
              :ref="'fileUpLoad'+index_x"></imgs>
      </div>
      <!--          mp3-->
      <div>
        <mp3 v-if="val.c_data_type==='Mp3'"
             :Data="{'obj':objType,'data':val,'attr':{'type':type,'oneIndex':oneIndex,'twoIndex':index_x,
             'des_id':des_id,'des_name':des_name}}"
             :ref="'fileUpLoad'+index_x"></mp3>
      </div>
      <!--          mp4-->
      <div>
        <mp4 v-if="val.c_data_type==='Mp4'"
             :Data="{'obj':objType,'data':val,'attr':{'type':type,'oneIndex':oneIndex,'twoIndex':index_x,
             'des_id':des_id,'des_name':des_name}}"
             :ref="'fileUpLoad'+index_x"></mp4>
      </div>
    </div>

  </div>
</template>

<script>
import inputBox from "@/components/IBMS/function/general_func_group/input"
import DTime from "@/components/IBMS/function/general_func_group/DTime"
import DTimer from "@/components/IBMS/function/general_func_group/DTimer"
import DTimers from "@/components/IBMS/function/general_func_group/DTimers"
import DTimes from "@/components/IBMS/function/general_func_group/DTimes"
import date from "@/components/IBMS/function/general_func_group/date"
import dates from "@/components/IBMS/function/general_func_group/dates"
import dater from "@/components/IBMS/function/general_func_group/dater"
import daters from "@/components/IBMS/function/general_func_group/daters"
import Time from "@/components/IBMS/function/general_func_group/time"
import times from "@/components/IBMS/function/general_func_group/times"
import timer from "@/components/IBMS/function/general_func_group/timer";
import timers from "@/components/IBMS/function/general_func_group/timers";

import fileAccess from "@/components/IBMS/function/general_func_group/file"
import radio from "@/components/IBMS/function/general_func_group/radio";
import numr from "@/components/IBMS/function/general_func_group/numr"
import nums from "@/components/IBMS/function/general_func_group/nums"
import number from "@/components/IBMS/function/general_func_group/number"
import checkbox from "@/components/IBMS/function/general_func_group/check";
import inputRange from "@/components/IBMS/function/general_func_group/input_range";
import boolSwitch from "@/components/IBMS/function/special_func_group/sole_select";
import txt from "@/components/IBMS/function/general_func_group/txt"
import imgs from "@/components/IBMS/function/general_func_group/imgs";
import mp3 from "@/components/IBMS/function/general_func_group/mp3";
import mp4 from "@/components/IBMS/function/general_func_group/mp4";


export default {
  name: "equip_attr_temp",
  components: {
    inputBox,
    radio,
    number,numr,nums,
    DTime,DTimer,DTimes,date,dater,dates,timers,DTimers,daters,
    Time,times,timer,
    fileAccess,
    checkbox,
    inputRange,
    boolSwitch,
    txt,
    imgs, mp3, mp4
  },
  props: ['Data'],
  data() {
    return {
      objType: this.Data.attr.objType,
      val: this.Data.data,
      oneIndex: this.Data.attr.oneIndex,
      type: this.Data.attr.type,
      index_x: this.Data.attr.twoIndex,
      des_id: this.Data.attr.des_id,//工单详情中，修改描述权限，修改单个属性值
      des_name: this.Data.attr.attr_name,//工单详情中，修改描述权限，修改单个属性值
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>